const normalizedConfiguredOrigin = (value) => String(value || '').trim().replace(/\/+$/, '');
const LOCAL_DEVELOPMENT_API_ORIGIN = 'https://api.casedb.co';

export const resolveCaseDbApiOrigin = (
    configuredOrigin = process.env.REACT_APP_API_BASE_URL,
    location = typeof window !== 'undefined' ? window.location : null
) => {
    const configured = normalizedConfiguredOrigin(configuredOrigin);
    if (configured) return configured;
    if (!location) return '';

    const { protocol = '', hostname = '', origin = '' } = location;
    if (!hostname || hostname.startsWith('api.')) {
        return origin;
    }
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') {
        return LOCAL_DEVELOPMENT_API_ORIGIN;
    }

    const labels = hostname.split('.').filter(Boolean);
    const applicationRoot = labels.length > 2 ? labels.slice(-2).join('.') : hostname;
    return `${protocol}//api.${applicationRoot}`;
};

export const caseDbApiOrigin = () => resolveCaseDbApiOrigin();

export const caseDbApiEndpoint = (path) => {
    const origin = caseDbApiOrigin();
    const normalizedPath = String(path || '').replace(/^\/+/, '');
    return origin ? `${origin}/${normalizedPath}` : `/${normalizedPath}`;
};
